import script from "./UserModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserModal.vue?vue&type=style&index=0&id=782183cc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782183cc"]])

export default __exports__